import React, { forwardRef } from 'react'
import { RowProps } from './row.types'
import { useStyle } from './row.styles'

export const Row = forwardRef<HTMLDivElement, RowProps>(
  (
    {
      alignItems,
      justifyContent,
      alignContent,
      className,
      children,
      fullHeight,
      fullWidth,
      ...props
    },
    ref
  ) => {
    const classes = useStyle({
      alignContent,
      alignItems,
      justifyContent,
      fullHeight,
      fullWidth
    })

    return (
      <div {...props} className={`${className || ''} ${classes.row}`} ref={ref}>
        {children}
      </div>
    )
  }
)
